var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"purchasable-item-nav"}},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{
        name: 'create_purchasable_item'
      }}},[_vm._v("\n        New Purchasable Item\n      ")])],1),_vm._v(" "),(_vm.purchasableItemId && this.$parent.$parent.role === 'admin')?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'edit_purchasable_item',
        params: { purchasableItemId: _vm.purchasableItemId }
        }}},[_vm._v("\n        Edit Purchasable Item\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.purchasableItemId && this.$parent.$parent.role === 'admin')?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'purchasable_item_purchases',
        params: { purchasableItemId: _vm.purchasableItemId }
        }}},[_vm._v("\n        View Sales Chart\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03943822","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchasableItemNav.vue
// module id = 1118
// module chunks = 1